const AppContainer = ({ children }) => {
  return (
    <div className="bg-white shadow-sm fixed inset-0 my-4 ml-4 mr-4 h-[calc(100vh-12%)] w-[92] lg:w-[98vw] rounded-xl   border border-blue-gray-100 mt-20 overflow-y-auto hide-scrollbar flex gap-x-7 md:gap-x-1 ">
      {children}
    </div>
  );
};

export default AppContainer;
